/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type CuraiRedirectContentActionTaken =
  | (typeof CuraiRedirectContentActionTaken)[keyof typeof CuraiRedirectContentActionTaken]
  | null;

export const CuraiRedirectContentActionTaken = {
  visit_started: "visit_started",
  visit_updated: "visit_updated",
} as const;
